import CTLUnReadCell from "application/components/CTLUnReadCell";
import { reportMenus } from "globals/configuration/reports";

const buildModes = () =>
  reportMenus.map((item) => ({
    id: item.key,
    name: item.name,
    iconName: item.icon,
    url: item.url,
    description: item.description,
    disabled: item.disabled,
    productionReady: item.productionReady,
  }));

const Attributes = {
  enableAddButton: false,
  enableUpdateTableRecords: false,
  enableDownloadButton: false,
  enableAdvanceSearch: false,
  enableDownloadPdf: false,
  enableRefresh: false,
  get modes() {
    return buildModes();
  },
};

// Relative to the application axios baseURL (/services/api/v2/) — ../v3/ resolves to /services/api/v3/
const operationURLS = {
  list: "../v3/pbx/cliCommandLog/list",
  count: "../v3/pbx/cliCommandLog/count",
  export: "../v3/pbx/cliCommandLog/export",
};

// 24 legacy-parity columns; 14 default-visible (displayInList: true) — Approved On added per QA parity.
const getColumns = () => [
  {
    Header: "CLI Command",
    accessor: "cliCommand",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => (
      <span style={{ whiteSpace: "normal", wordBreak: "break-word", display: "block" }}>
        {value}
      </span>
    ),
  },
  {
    Header: "Record Created On",
    accessor: "recordCreatedOn",
    displayInList: true,
    allowFilter: false,
    dataType: "date",
    Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{value}</span>,
  },
  {
    Header: "Record Created By",
    accessor: "recordCreatedBy",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Executed By IP",
    accessor: "commandExecutedByClientIP",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Executed On IP",
    accessor: "commandExecutedOnServerIP",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Execution Started",
    accessor: "executionStarted",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Execution Start Time",
    accessor: "executionStartTime",
    displayInList: true,
    allowFilter: false,
    dataType: "date",
    Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{value}</span>,
  },
  {
    Header: "Execution End Time",
    accessor: "executionEndTime",
    displayInList: true,
    allowFilter: false,
    dataType: "date",
    Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{value}</span>,
  },
  {
    Header: "Is Error",
    accessor: "isError",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Error Message",
    accessor: "errorMessage",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Executed",
    accessor: "executed",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Record Source",
    accessor: "recordSource",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Approved By",
    accessor: "approvedBy",
    displayInList: true,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Approved On",
    accessor: "approvedOn",
    displayInList: true,
    allowFilter: false,
    dataType: "date",
    Cell: ({ value }) => <span style={{ whiteSpace: "nowrap" }}>{value}</span>,
  },
  // ── Hidden by default (displayInList: false) ──────────────────────────────
  {
    Header: "ID",
    accessor: "id",
    displayInList: false,
    allowFilter: false,
    dataType: "integer",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Output File Name",
    accessor: "outputFileName",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Output File Path",
    accessor: "outputFilePath",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Execution Command",
    accessor: "executionCommand",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Execution Done By",
    accessor: "executionDoneBy",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "File Moved To Processed",
    accessor: "fileMovedToProcessed",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Processed Folder Path",
    accessor: "processedFolderPath",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Remarks",
    accessor: "remarks",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Record ID",
    accessor: "recordId",
    displayInList: false,
    allowFilter: false,
    dataType: "integer",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
  {
    Header: "Server Code",
    accessor: "serverCode",
    displayInList: false,
    allowFilter: false,
    dataType: "string",
    Cell: ({ value }) => <CTLUnReadCell value={value} />,
  },
];

export { Attributes, operationURLS, getColumns };
